<template>
    <div>
        <el-dialog
            :title="title"
            :visible.sync="showdialog"
            width="1200px"
            @close="back">

            <div class="base-warp">
                <div class="head">
                    <tutor-project @getProject="getProject" v-if="regions" :regions="regions"></tutor-project>
                </div>
                <div class="table-box">
                    <div class="table-box">
                    <el-table 
                    :data="tableData" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="name" label="楼盘名称" show-overflow-tooltip></el-table-column>
                        <el-table-column label="物业类型" show-overflow-tooltip align="center">
                            <template slot-scope="s">
                                <div v-if="s.row.housetype">
                                    <span class="btn-text" v-for="(item, index) in JSON.parse(s.row.housetype)" :key="index">{{item}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" show-overflow-tooltip align="center">
                            <template slot-scope="s">
                                <span class="text-success" v-if="s.row.putaway">上架</span>
                                <span class="text-danger" v-else>下架</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="region" label="区域" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="average_price" label="当前单价" show-overflow-tooltip>
                            <template slot-scope="s">
                                <span v-if="s.row.average_price">{{s.row.average_price}}元/㎡</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="专属优惠" width="300" show-overflow-tooltip>
                            <template slot-scope="s">
                                <div class="flex-box">
                                    <!-- <el-input class="disinput" v-model="s.row.discounts" placeholder="导师专属优惠8.8折" size="mini" clearable></el-input> -->
                                    <input class="disinput" type="text" v-model="s.row.discounts" placeholder="导师专属优惠8.8折">
                                    <el-button type="primary" size="mini" @click="edit(s.row)" plain>保存</el-button>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="index" label="操作" width="80">
                            <template slot-scope="s">
                                <el-button type="danger" size="mini" @click="del(s.$index)" >删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                </div>
            </div>

        </el-dialog>
        
    </div>
</template>

<script>
import tutorProject from '../../../components/tutor-project.vue';
    export default {
        components: { 
            tutorProject 
        },
        data() {
            return {
                showdialog: true,
                tableData: [],
                id: '',
                title: '',
                regions: [],
                recommend: [],
            }
        },
        mounted () {
            this.id = this.$route.query.id;
            var name = this.$route.query.name;
            this.title = name+'推荐楼盘';
            this.getTableData();
            this.getCityList();
        },
        computed: {
            
        },
        methods: {
            getTableData() {
                var params = {
                    id: this.id
                }
                this.$api.getTutorRecommoned(params).then(
                    data=>{
                        this.tableData = data;
                    }
                )
            },
            formateRcommend: function() {
                let datas = this.tableData;
                if(datas.length>0){
                    var arr = [];
                    for(var data of datas){
                        var obj = {
                            projectid: data._id['$oid'],
                            discounts: data.discounts,
                        }
                        arr.push(obj);
                    }
                    console.log(arr);
                    this.recommend = arr;
                }
                var params = {
                    id: this.id,
                    recommend: JSON.stringify(this.recommend),
                }
                this.$api.editTutorRecommoned(params).then(
                    data=>{
                        this.$message.success(data);
                    }
                )
            },
            edit() {
                this.formateRcommend();
            },
            del(index) {
                this.tableData.splice(index, 1);
                this.formateRcommend();
            },
            getProject(e) {
                e.discounts = '';
                this.tableData.push(e);
                // this.formateRcommend();
            },
            getCityList() {
                this.$api.getCityList('').then(
                    data=>{
                        this.regions = data;
                    }
                )
            },
            back() {
                this.$router.go(-1);
            },
        },
    }
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
.disinput{
    width: 200px;
    border: 1px solid #eee;
}
</style>